import { call, put, takeEvery } from 'redux-saga/effects';

import {
  OTP_TIMER,
  otpTimerBegin,
  otpTimerFailure,
  otpTimerSuccess,
  VALIDATE_OTP,
  validateOtpBegin,
  validateOtpFailure,
  validateOtpSuccess,
} from './actions';
import { fetchOtpTimer, validateOtp } from './service';

export function* handleValidateOtp(action) {
  try {
    yield put(validateOtpBegin());
    const { code, token, email } = action.payload;
    const data = yield call(validateOtp, code, { token, email });
    if (!data) {
      yield put(validateOtpFailure());
    } else {
      yield put(validateOtpSuccess(data.reset_link));
    }
  } catch (err) {
    yield put(validateOtpFailure());
  }
}

export function* handleFetchOtpTimer(action) {
  try {
    put(otpTimerBegin());
    const { token, email } = action.payload;
    const data = yield call(fetchOtpTimer, { token, email });
    yield put(otpTimerSuccess(data));
  } catch (err) {
    yield put(otpTimerFailure(err.response.data));
  }
}

export default function* saga() {
  yield takeEvery(VALIDATE_OTP.BASE, handleValidateOtp);
  yield takeEvery(OTP_TIMER.BASE, handleFetchOtpTimer);
}
